export function ReactWidget({ payload }) {
  return (
    <div
      className="nova-react-widget__content"
      data-widget-type={payload.type}
      dangerouslySetInnerHTML={{ __html: payload.html || '' }}
    />
  )
}
